import { render } from "./DexBodyCell.vue?vue&type=template&id=95fa8c6c"
import script from "./DexBodyCell.vue?vue&type=script&lang=js"
export * from "./DexBodyCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__